import React from "react";

import AppButton from "../../../components/AppButton";

import "./card.styles.css";
const Card = () => {
  return (
    <div className="card__container">
      <header>
        <span className="klen--tag">virtually interactive</span>
      </header>
      <main>
        <div className="teacher--card d-flex align-items-center">
          <span className="teacher--cardTag">M</span>
          <div className="teacher--cardDetails">
            <h6 className="font--medium">Maya James</h6>
          </div>
        </div>
        <div className="separator"></div>
        <h4>Team work makes the dream work.</h4>
        <p>
          The thing is when team work together, the dream work together, so fuck
          off
        </p>
        <AppButton title="Start Playing" />
      </main>
    </div>
  );
};

export default Card;
